var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#7e91b5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.98-.002H11.021a11.02 11.02 0 00-11.02 11.02v17.959a11.02 11.02 0 0011.02 11.02H28.98A11.02 11.02 0 0040 28.977V11.02A11.02 11.02 0 0028.98-.002zm8.031 28.951a8.06 8.06 0 01-8.06 8.06h-17.9a8.06 8.06 0 01-8.06-8.06v-17.9a8.06 8.06 0 018.06-8.059h17.9a8.06 8.06 0 018.06 8.059z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12.454A7.546 7.546 0 1027.546 20 7.546 7.546 0 0020 12.454zm0 12.969A5.423 5.423 0 1125.423 20 5.423 5.423 0 0120 25.427zM30.691 6.559a2.749 2.749 0 102.749 2.75 2.749 2.749 0 00-2.749-2.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.c3ba26c5dc3d337055c08f27f0875387.svg";
export { ForwardRef as ReactComponent };